import {KnowledgeRagTopic} from 'common/src/modules/ai/ai.enums';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {ZodTypeAny} from 'zod';
import {AgentContext, Tool} from '../../copilot.types';
import {SkillName} from '../../skills/skills.enums';
import {Skill} from '../../skills/skills.types';
import askKnowledgeRAGTool from '../../tools/askKnowledgeRAGTool/askKnowledgeRAGTool';

type CreateSkillParams = {
  name: SkillName;
  description: string;
  whenToUse: string;
  whenToAvoid?: string;
  instructions: string;
  tools: Tool<ZodTypeAny>[];
  applicableBreadcrumbs: BreadcrumbName[];
  contextBuilders?: AgentContext[];
  knowledgeTopics?: KnowledgeRagTopic[];
};

export default function skill({
  name,
  description,
  whenToUse,
  whenToAvoid = '',
  instructions,
  tools,
  applicableBreadcrumbs,
  contextBuilders = [],
  knowledgeTopics = [],
}: CreateSkillParams): Skill {
  const skillTools = [...tools];

  if (knowledgeTopics.length > 0) {
    skillTools.push(askKnowledgeRAGTool({knowledgeTopics, nameSuffix: name}));
  }

  return {
    name,
    description,
    whenToUse,
    whenToAvoid,
    instructions,
    tools: skillTools,
    contextBuilders,
    knowledgeTopics,
    applicableBreadcrumbs,
  };
}
